"use strict";
var ACC;

ACC.productDetail = {
	_autoload: [
		"initPageEvents",
		"productDescriptionScroll",
		"imageResponsiveSrc",
		"galleryImageView",
		"disableZoomForMobileAppAndroid"
	],

	_defaultSettings: {
		MOBILE_MAX_BP: 640,
		TABLET_MIN_BP: 768,
		TABLET_MAX_BP: 1024
	},

	imageResponsiveSrc: function() {
		$(document).ready(function(){
			var prdDetail = ACC.productDetail,
				$zoomImg = $('.MagicZoom'),
				defaultSettings = prdDetail._defaultSettings,
				breakpoints;

			breakpoints = [{
					media: "(max-width:"+defaultSettings.MOBILE_MAX_BP+"px)",
					type: 'mobile'
				}, {
					media: "(min-width:"+(defaultSettings.MOBILE_MAX_BP + 1)+"px) and (max-width:"+defaultSettings.TABLET_MIN_BP+"px)",
					type: 'tablet'
				}, {
					media: "(min-width:"+(defaultSettings.MOBILE_MAX_BP + 1)+"px) and (max-device-width:"+defaultSettings.TABLET_MAX_BP+"px) and (orientation: landscape)",
					type: 'tablet'
				}, {
					media: "(min-width:"+(defaultSettings.TABLET_MIN_BP + 1)+"px)",
					type: 'desktop'
				}
			];

			$zoomImg.each(function() {
				var $this = $(this),
					desktopSrc = $this.attr('href'),
					$magicZoomImage = $(this).find('.magic-zoom-image'),
					matched= false,
                    createSrc = function (bp) {
                        enquire.register(bp.media, function() {
                            $('.magic-zoom-image-preload').remove();
                            if(bp.type !== 'desktop') {
                                $magicZoomImage.attr('src', $magicZoomImage.data(bp.type+'-image'));
                                ACC.productDetail.displayElement('.magic-zoom-image');
                                $this.attr('href', $this.data(bp.type+'-image'));
                                matched = true;
                            } else {
                                if(!matched) {
                                    $magicZoomImage.attr('src', $magicZoomImage.data('src'));
                                    ACC.productDetail.displayElement('.magic-zoom-image');
                                    $this.attr('href', desktopSrc);
                                }
                            }
                        });
                    };


				for(var i = 0; i< breakpoints.length; i++) {
					var breakpoint = breakpoints[i];
					createSrc(breakpoint);
				}

			});

		});
	},

	/*
	 Product gallery Images
	*/
	galleryImageView: function() {
		var screenSize = $(window).width(),
			defaultSettings = ACC.productDetail._defaultSettings,
			imgSrc;

		if(screenSize > defaultSettings.MOBILE_MAX_BP) {
			$(".pdp-product-image-nav picture source").each(function () {
			       imgSrc = $(this).data("srcset");
			       this.srcset = imgSrc;
		   	});
		}
	},

	isAndroidDevice: function () {
		return navigator?.userAgent?.toLowerCase().includes('android') || false;
	},

	disableZoomForMobileAppAndroid: function() {
		let isAndroid = ACC.productDetail.isAndroidDevice();

		if (isAndroid && ACC.isMobileApp) {
			const magicZoomLink = document.querySelector('.MagicZoom');
			if (magicZoomLink && magicZoomLink.hasAttribute('data-mobile-options')) {
				// Add the 'zoomMode: off' to the data-mobile-options attribute
				let mobileOptions = magicZoomLink.getAttribute('data-mobile-options') || '';
				mobileOptions += (mobileOptions ? '; ' : '') + 'zoomMode: off';

				// Set the updated data-mobile-options attribute
				magicZoomLink.setAttribute('data-mobile-options', mobileOptions);
			}
		}
	},

	stopMagicZoom: function() {
        const magicZoomImages = document.querySelectorAll('.MagicZoom');
        magicZoomImages.forEach(function(image) {
            MagicZoom.stop(image);
        });
    },

    startMagicZoom: function() {
        const magicZoomImages = document.querySelectorAll('.MagicZoom');
        magicZoomImages.forEach(function(image) {
            MagicZoom.start(image);
        });
    },

	checkQtySelector:function(self,mode){
		var $input= $(self).parents(".js-qty-selector").find(".js-qty-selector-input");
		var inputVal = parseInt($input.val());
		var max= $input.data("max");


		var $minusBtn= $(self).parents(".js-qty-selector").find(".js-qty-selector-minus");
		var $plusBtn= $(self).parents(".js-qty-selector").find(".js-qty-selector-plus");


		$(self).parents(".js-qty-selector").find(".btn").removeAttr("disabled");

		if(mode==="minus"){
			if(inputVal !== 1){
				ACC.productDetail.updateQtyValue(self,inputVal-1);
				if(inputVal-1 === 1){
					$minusBtn.attr("disabled","disabled");
				}

			}else{
				$minusBtn.attr("disabled","disabled");
			}
		}else if(mode==="reset"){
			ACC.productDetail.updateQtyValue(self,1);

		}else if(mode==="plus"){
			if(inputVal !== max){
				ACC.productDetail.updateQtyValue(self,inputVal + 1);
				if(inputVal+1 === max){
					$plusBtn.attr("disabled","disabled");
				}
			}else{
				$plusBtn.attr("disabled","disabled");
			}
		}else if(mode==="input"){
			if(inputVal === 1){
				$(self).parents(".js-qty-selector").find(".js-qty-selector-minus").attr("disabled","disabled");
			}else if(inputVal === max){
				$(self).parents(".js-qty-selector").find(".js-qty-selector-plus").attr("disabled","disabled");
			}else if(inputVal<1){
				ACC.productDetail.updateQtyValue(self,1);
				$(self).parents(".js-qty-selector").find(".js-qty-selector-minus").attr("disabled","disabled");
			}else if(inputVal>max){
				ACC.productDetail.updateQtyValue(self,max);
				$(self).parents(".js-qty-selector").find(".js-qty-selector-plus").attr("disabled","disabled");
			}
		}

	},

    displayElement: function(classSelector) {
        if ($(classSelector).hasClass('u-visually-hidden')) {
            $(classSelector).removeClass('u-visually-hidden');
        }
    },

	updateQtyValue: function(self,value){
		var input= $(self).parents(".js-qty-selector").find(".js-qty-selector-input");
		var addtocartQty= $(self).parents(".addtocart-component").find("#addToCartForm").find(".js-qty-selector-input");

		input.val(value);
		addtocartQty.val(value);
	},
	updateVariantAddToCartQtyValue: function(value){
		var addtocartQty= $("#addToCartForm").find(".js-qty-selector-input");
		addtocartQty.val(value);
	},
	initPageEvents: function ()
	{
		$(document).on("click",'.js-qty-selector .js-qty-selector-minus',function(){
			ACC.productDetail.checkQtySelector(this,"minus");
		});
		$(document).on("click",'.js-qty-selector .js-qty-selector-plus',function(){
			ACC.productDetail.checkQtySelector(this,"plus");
		});

		$(document).on("keydown",'.js-qty-selector .js-qty-selector-input',function(e){
			if(e.which === 38 ){
				ACC.productDetail.checkQtySelector(this,"plus");
			}
			else if(e.which === 40 ){
				ACC.productDetail.checkQtySelector(this,"minus");
			}
			else{
				e.preventDefault();
			}
		});
		$(document).on("keyup",'.js-qty-selector .js-qty-selector-input',function(){
			ACC.productDetail.checkQtySelector(this,"input");
			ACC.productDetail.updateQtyValue(this,$(this).val());
		});
		$("#Size").change(function () {
			var url = "";
			var selectedIndex = 0;
			$("#Size option:selected").each(function () {
				url = $(this).attr('value');
				selectedIndex = $(this).attr("index");
			});
			if (selectedIndex !== 0) {
				window.location.href=url;
			}
		});

		$("#variant").change(function () {
			var url = "";
			var selectedIndex = 0;
			$("#variant option:selected").each(function () {
				url = $(this).attr('value');
				selectedIndex = $(this).attr("index");
			});
			if (selectedIndex !== 0) {
				window.location.href=url;
			}
		});

		$(document).on("change",'.pdp-quantity-select',function(){
            var $this = $(this);
			var qty = $this.val();
            var productCode = $this.data('product-code');
            var variant = ACC.common.getVariant();
			ACC.productDetail.updateVariantAddToCartQtyValue(qty);
            ACC.gtm.trackSelectedQuantityEvent(productCode, qty, variant, '', '');
		});

	},
	bindVariantOptions: function()
	{
		ACC.productDetail.bindCurrentStyle();
		ACC.productDetail.bindCurrentSize();
		ACC.productDetail.bindCurrentType();
		ACC.productDetail.bindVariantSize();
		ACC.productDetail.bindBundleVariant();
	},

	bindBundleVariant: function() {
		var $prodbundleVariant = $('#prod-bundle-variant'),
			$dropdownMenu = $('#prod-bundle-variant .dropdown-menu'),
			$options = $('#prod-bundle-variant li:not(.disabled)'),
			$bundlePrice = $('.bundle-price'),
			$deliveryMessage = $('.delivery-offer-panel'),
            $errorMessage = $('#variant_select_size_error'),
			priceObj = {};

		$prodbundleVariant.on('keydown', 'li', function(event) {
			// tab key
			if (event.which === 9) {
				event.preventDefault();
			}
		});

		$prodbundleVariant.on('click', 'li', function(event) {
			event.stopPropagation();

			var $selected = $(this),
				variantCode = $selected.data('code'),
				$button = $selected.closest('.dropdown').find('button'),
				bundleProductName = $selected.find('.bundle-product-name').text(),
				bundleProductPrice = $selected.find('.bundle-product-price').text(),
				showFreeDeliveryBanner = $selected.data('show-delivery-message');

			if(!$selected.hasClass('disabled')) {

				//update button text
				$button.find('.bundle-product-name').text(bundleProductName);
				$button.find('.bundle-product-name').attr('title', bundleProductName);
				$button.find('.bundle-product-price').text(bundleProductPrice);
				window.bootstrap.Dropdown.getOrCreateInstance($button[0]).toggle();
				$prodbundleVariant.data('value',variantCode);

				// update active class and aria-selected attribute
				$options.attr('aria-selected', false);
				$options.removeClass('selected');
				$selected.attr('aria-selected', true);
				$selected.addClass('selected');
				$dropdownMenu.attr('aria-activedescendant', $selected.attr('id'));

				//created JS object of price values
				priceObj = {
					'webPrice' : $selected.data('price-value'),
					'rrpPrice' : $selected.data('rrp-value'),
					'wasPrice' : $selected.data('was-price-value'),
					'savePrice' : $selected.data('save-value'),
					'stockValue': $selected.data('stock-value')
				};

				ACC.productDetail.updateBundlePrice($selected, priceObj);
				$('input[name="productCodePost"]').val(variantCode);
				$('#pdp-quantity').attr('disabled',false).selectric('refresh');
				$errorMessage.hide().removeClass('visible');
				$bundlePrice.show();

				$deliveryMessage.toggleClass('hidden', !showFreeDeliveryBanner);

				var NO_SIZE = 'nosize';
				var quantity = $('select#pdp-quantity option:selected').val();
				ACC.gtm.trackSizeSelectEvent(variantCode, quantity, NO_SIZE, '', '');
				ACC.productDetail.updateVariantAddToCartQtyValue('1');
			}
		});

		/*
		 * #prod-bundle-variant now runs on the Bootstrap 5 Dropdown component,
		 * which dispatches plain native events rather than jQuery-triggered ones,
		 * so these must be bound with `addEventListener` (jQuery's `.on()` would
		 * never see them).
		 */
		if (Array.isArray($prodbundleVariant.toArray()) && $prodbundleVariant.length > 0) {
			$prodbundleVariant[0].addEventListener('shown.bs.dropdown', function(event){
				// set focus to the selected or first item
				if ($options.length > 0) {
					var $focusableOption = $options.filter('.selected').length > 0 ?
						$options.filter('.selected') :
						$options.first();
					$focusableOption.find('a').trigger('focus');
					$errorMessage.hide().removeClass('visible');
				}
			});

			$prodbundleVariant[0].addEventListener('hide.bs.dropdown', function(event){
				// return focus to the toggle button
				const toggle = '[data-bs-toggle="dropdown"]';
				$(this).find(toggle).trigger('focus');
			});
		}
	},

	updateBundlePrice: function($this, priceObj) {
		var $bundlePrice = $('.bundle-price'),
			stockValue = 10,
			maxQty;

		for(var priceKey in priceObj) {
			$bundlePrice.find('#item-'+priceKey).html(priceObj[priceKey]);

			if(priceKey === 'wasPrice') {
				if(!priceObj[priceKey]) {
					$bundlePrice.find('p#item-webPrice').removeClass('item-price-red');
					$bundlePrice.find('p#item-webPrice').addClass('item-price-original');
				} else {
					$bundlePrice.find('p#item-webPrice').addClass('item-price-red');
					$bundlePrice.find('p#item-webPrice').removeClass('item-price-original');
				}
			}

			if(priceKey === 'stockValue') {
				if(priceObj[priceKey]) {
					$bundlePrice.find('#item-'+priceKey).show();
					stockValue = priceObj[priceKey].replace( /\D+/g, '');
				}
				maxQty = stockValue;
				if (maxQty >= 10) {
					maxQty = 10;
				} else {
					maxQty = $this.data('actual-stock');
				}
				$(".pdp-quantity-select").find("option").remove();

				for(var i = 1; i <= maxQty; i++){
					$(".pdp-quantity-select").append('<option value="' + i + '">' + i + '</option>');
				}
			}
		}
	},

	bindCurrentStyle: function(){
		var currentStyle = $("#currentStyleValue").data("styleValue");
		var styleSpan = $(".styleName");
		if (currentStyle != null) {
			styleSpan.text(": " + currentStyle);
		}

	},

	bindCurrentSize: function(){
		var currentSize = $("#currentSizeValue").data("sizeValue");
		var sizeSpan = $(".sizeName");
		if(currentSize != null){
			sizeSpan.text(": " + currentSize);
		}
	},

	bindCurrentType: function(){
		var currentSize = $("#currentTypeValue").data("typeValue");
		var sizeSpan = $(".typeName");
		if(currentSize != null){
			sizeSpan.text(": " + currentSize);
		}
	},

	bindVariantSize : function() {
		var $productSizeForm = $('#product');

		$productSizeForm.on('sizeSelectInit', function () {
			var $sizeInputs = $productSizeForm.find('input'),
				$qtySelect = $('.pdp-quantity-select'),
				$productCodeInput = $('#addToCartForm input[name="productCodePost"]'),
				$selectedOption = $sizeInputs.filter('[checked]'),
				selectedOptionCode = $selectedOption.data('product-code'),
				$errorMessage = $('#variant_select_size_error');

			$sizeInputs.on('change', function() {
				var $selectedInput = $(this),
					inputId = $selectedInput.attr('id'),
					$selectedVariantLabel = $productSizeForm.find('label[for="' + inputId + '"]'),
					selectedOptionCode = $selectedInput.data('product-code'),
					stockValue = parseInt($selectedVariantLabel.data('stock-value'), 10),
					maxQty = stockValue > 10 ? 10 : stockValue,
					i;

				if($(this).closest("fieldset").attr('aria-invalid') === "true") {
					$(this).closest("fieldset").attr('aria-invalid', "false");
				}

				$sizeInputs.removeAttr('checked');
				$sizeInputs.prop('checked', false);

				$selectedInput.attr('checked', 'checked');
				$selectedInput.prop('checked', true);

				$productCodeInput.val(selectedOptionCode);

				$qtySelect.find('option').remove();

				for (i = 1; i <= maxQty; i++) {
					$qtySelect.append('<option value="'+i+'">'+i+'</option>');
				}

				$qtySelect.selectric('refresh');

				$errorMessage.hide().removeClass('visible');

				$('.stock-status-label').hide().filter('.stock-status-label-' + selectedOptionCode).show();

				ACC.productDetail.updateVariantAddToCartQtyValue(1);

				var variant = $("label[for='"+inputId+"']").text();
				var quantity = $('select#pdp-quantity option:selected').val();
				ACC.gtm.trackSizeSelectEvent(selectedOptionCode, quantity, variant, '', '');
			});

			selectedOptionCode && $productCodeInput.val(selectedOptionCode);

			// runs here (rather than right after ajaxGetSizes) since .variantlabel only exists once this event fires
			ACC.productDetail.bindSizeWidth();
		});
	},

	setProductQuantityStatus(message) {
		$('#quantity_status').text('');
		$('#quantity_status').text(message);
	},

	productDescriptionScroll: function(){

		$(document).ready(function(){
			$parent.find(".tabhead.last a").attr('id','size-guide');
		});
		function scroll_if_anchor(href) {
			href = typeof(href) === "string" ? href : $(this).attr("href");
			var fromTop = 95;
			if(href.indexOf("#") === 0) {
				var $target = $(href);

				// Older browser without pushState might flicker here, as they momentarily
				// jump to the wrong position (IE < 10)
				if($target.length) {
					$('html, body').animate({ scrollTop: $target.offset().top - fromTop });
					if(history && "pushState" in history) {
						history.pushState({}, document.title, window.location.pathname + href);
						return false;
					}
				}
			}
		}

        scroll_if_anchor(window.location.hash);
		var $parent = $('.pdp-tabs.js-tabs');
		$(document).ready(function() {
			$("#accessibletabscontent0-0").addClass('active').children('a').attr('aria-expanded', 'true');
            $("#accessibletabscontent0-1, #accessibletabscontent0-2, #accessibletabscontent0-3").removeClass('active').children('a').attr('aria-expanded', 'false');
			$(".tabbody").hide();
			$("#accessibletabscontent0-0").next(".tabbody").show();
			$parent.find('.icon.icon-up-open-big').removeClass('icon-up-open-big').addClass('icon-down-open-big');
			$("#accessibletabscontent0-0").find('.icon').removeClass('icon-down-open-big').addClass('icon-up-open-big');
		});

		$("body").on("click", ".size-guide-box a", scroll_if_anchor);

		// Open Size Guide Tab
		$(document).on('click', '.size-guide-link', function() {
			var $target = $(this).data('target'),
				linkUrl = $(this).data('link');

			/*
				- these aditional session storage interactions were added as part of the Chatbot feature ECOM-16063
				- the chatbot needs to stay open for the current tab/browser window, but if you close it, the session data
					should be erased. each new tab should have its own data inside session storage
				- this thing right here is trying to fix a potential issue (it was regarded as a bug but w/e):
					* on a pdp, click on size guide
					* it opens an entirely new tab and the chatbot should NOT be present on the new tab
					* it seems that window.open actually copies data from the parent window to the new one
						and the chatbot was visible there as well
					* by clearing session storage before window.open and repopulating it after the call, seems to fix it
			*/
			var chatbotSettings = {
				'chatbot_base_url': '',
				'chatbot_country_code': '',
				'chatbot_language_code': '',
				'chatbot_skip_history': '',
				'chatbot_engaged': ''
			};
			var botSessionKeys = Object.keys(chatbotSettings);
			// if one of the chatbot keys exists, then i know the chatbot is active and there are multiple keys
			if (window.sessionStorage.getItem('chatbot_base_url')) {
				botSessionKeys.forEach(function(key) {
					chatbotSettings[key] = window.sessionStorage.getItem(key);
					window.sessionStorage.removeItem(key);
				});
			}
			window.open(linkUrl, $target);
			if (chatbotSettings['chatbot_base_url'] !== '') {
				// chatbotSettings will be populated ONLY when the variables were previously set
				botSessionKeys.forEach(function(key) {
					window.sessionStorage.setItem(key, chatbotSettings[key]);
				});
			}
			$("#accessibletabsnavigation0-0, #accessibletabscontent0-0, #accessibletabscontent0-1, #accessibletabscontent0-2").removeClass('active');
			$("#accessibletabsnavigation0-3, #accessibletabscontent0-3").addClass('active');
			$(".tabbody").hide();
			$("#accessibletabscontent0-3").next(".tabbody").show();
			$parent.find('.icon.icon-up-open-big').removeClass('icon-up-open-big').addClass('icon-down-open-big');
			$("#accessibletabscontent0-3").find('.icon').removeClass('icon-down-open-big').addClass('icon-up-open-big');
		});

	},

	ajaxGetSizes:function(){
		var sizeUrl = `${ACC.config.encodedContextPath}/view/ProductVariantSelectorComponentController`;
		$.ajax({
			url : sizeUrl,
			type : "GET",
			data : {
				componentUid : $('input[name="variantSelectorUid"]').val(),
				product : $('input[name="productCodePost"]').val()
			},
			async : false,
			success: function (data) {
				$('#variantSizes').replaceWith(data);
				ACC.product.enableVariantSelectors();
				ACC.productDetail.bindVariantOptions();
			}
		});
	},
	ajaxAddToCart:function(){
		$.ajax({
			url : `${ACC.config.encodedContextPath}/view/DefaultCMSComponentController`,
			type : "GET",
			data : {
				componentUid : "AddToCartComponent"
			},
			async : false,
			success : function(data) {
				$('#addToCartComponent').replaceWith(data);
				ACC.product.enableAddToCartButton();
				ACC.product.bindToAddToCartForm();
			}
		});
	},
	populateBackLink: function() {
		var $categoryPattern = '/c/';
		var $referrerParser = document.createElement('a');
		$referrerParser.href = document.referrer;
		var $backlinkPath = $referrerParser.pathname;

		if($backlinkPath.indexOf($categoryPattern) != -1) {
			var $backlinkQuery = $referrerParser.search;
			var $backlinkBuff = $backlinkPath.split($categoryPattern)[0].split('/');
			var $backlinkTitle = $backlinkBuff[$backlinkBuff.length-1].replace("+"," & ");

			$('#breadcrumb ul.breadcrumb').prepend('<li class="backlink additionalLink"><a href="'+$backlinkPath+$backlinkQuery+'" class="back" data-node="backlink"><i class="icon icon-left-open-mini" aria-hidden="true"></i> '+$backlinkTitle+'</a></li>')
		}
	},
    showShortBreadcrumb: function() {
        var breadcrumbItems = $('.breadcrumb-item');
        breadcrumbItems.each((index, item) => {
            if (index == 1 || index == 2) {
                $(item).addClass('u-show');
            }
            if (index == 2) {
                $(item).find('.icon.icon-right-open-mini').addClass('u-hide');
            }
        })
    },
    bindSizeWidth: function() {
        setTimeout( function() {
            var $variantlabel = $('.variantlabel');
            if ($variantlabel.length > 0) {
                $.each( $variantlabel, function() {
                    var sizeWidth = $(this).width();
                    if (sizeWidth > 40) {
                        $(this).addClass('size-type-two');
                    } else {
                        $(this).addClass('size-type-one');
                    }
                });
            }
        },30);
    }
};
$(document).ready(function(){
	if($(".pdp-info-block").length){
	    ACC.productDetail.ajaxGetSizes();
	    ACC.productDetail.ajaxAddToCart();
        var screenSize = $(window).width(),
			defaultSettings = ACC.productDetail._defaultSettings;
		if (screenSize > defaultSettings.MOBILE_MAX_BP) {
            ACC.productDetail.populateBackLink();
		} else {
            ACC.productDetail.showShortBreadcrumb();
        }
        // activate selectric for q.ty select
        $('#pdp-quantity').accessibleSelectric();
        $('#pdp-quantity').on('selectric-change', function(event, element, selectric) {
            var current = selectric.state.currValue;
            var message = $(this).data('change-status-text') + ' ' + selectric.items[current].value;
            ACC.productDetail.setProductQuantityStatus(message);
        });
        $('#pdp-quantity').on('selectric-refresh', function(event, element, selectric) {
            var message = $(this).data('reset-status-text');
            var lastMessage = $('#quantity_status').text();
            if (lastMessage != message) {
                ACC.productDetail.setProductQuantityStatus(message);
            }
        });
	}
});

let isAndroid = ACC.productDetail.isAndroidDevice();

if (isAndroid && ACC.isMobileApp) {
	document.addEventListener('DOMContentLoaded', function() {
		ACC.productDetail.stopMagicZoom();
	});

	window.addEventListener('load', function() {
		ACC.productDetail.startMagicZoom();
	});
}
